'use client';
import { useMemo } from 'react';
import { clsx } from 'clsx';
import { usePathname } from 'next/navigation';
import Link from '../Link/Link';
import styles from './EpgDateNavigation.module.scss';

const BASE_PATH = '/fernsehprogramm/';
const FUTURE_DAYS = 6;

export const EpgDateNavigation = () => {
  const pathname = usePathname();
  const today = useMemo(() => new Date(), []);

  const todayFormatted = useMemo(() => {
    return today.toISOString().split('T')[0];
  }, [today]);

  const lastSegment = pathname?.split('/').filter(Boolean).pop() ?? '';
  const isValidDate = /^\d{4}-\d{2}-\d{2}$/.test(lastSegment);
  const currentPathDate = isValidDate ? lastSegment : todayFormatted;

  const dates = useMemo(() => {
    return Array.from({ length: 2 + FUTURE_DAYS }, (_, index) => {
      const date = new Date(today);
      date.setDate(date.getDate() + index - 1);
      return date;
    });
  }, [today]);

  const formatDate = (date: Date) => date.toISOString().split('T')[0];

  const formatLabel = (date: Date, index: number): string => {
    if (index === 0) return 'Gestern';
    if (index === 1) return 'Heute';

    const weekday = date.toLocaleDateString('de-DE', { weekday: 'short' }).replace('.', '').toUpperCase();
    const day = date.toLocaleDateString('de-DE', { day: '2-digit' });
    const month = date.toLocaleDateString('de-DE', { month: 'short' }).replace('.', '');

    return `${weekday} ${day}. ${month}`;
  };

  return (
    <nav className={styles.root}>
      <ul className={styles.list}>
        {dates.map((date, index) => {
          const dateString = formatDate(date);
          const isActive = currentPathDate === dateString;

          return (
            <li key={dateString} className={styles.listItem}>
              <Link
                key={formatDate(date)}
                className={clsx(styles.link, { [styles.active]: isActive })}
                href={`${BASE_PATH}${dateString}`}
              >
                {formatLabel(date, index)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
